export type PulseShareResponseData = {
  users: Array<PulseShareUser>
}

export type Proposal = {
  id: number
  ownerName: string
  ownerUrl: string
  status: 'open' | 'in_progress' | 'submitted'
  ownerId: number
}
export const pulseShareTypes = {
  PREPARE: 'prepare',
  REVIEW: 'review',
} as const

export type PulseShareType =
  typeof pulseShareTypes[keyof typeof pulseShareTypes]

export type PulseShareUser = {
  id: number
  shared: boolean
  name: string
  email: string
  shareType?: PulseShareType
}

export type UserLocalUpdatePayload = {
  shared?: boolean
  shareType?: PulseShareType
}

export type UserUpdatePayload = {
  id: number
  shareType: PulseShareType
}
